import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import "../../assets/style/main.css";
import $ from 'jquery'
import {Camera} from "react-camera-pro";
import { createWorker } from 'tesseract.js';
import moment from "moment-timezone";
import { useDispatch, useSelector } from "react-redux";
import IDCARD_FRAME from '../../assets/images/icons/idcard-frame.png'
import CAPTURE_ICON from '../../assets/images/icons/cam-bt.png'
import PageLoader from "../../components/PageLoader";
import { isPageLoading } from "../../components/PageLoader";
import ContentLoader from "../../components/ContentLoader";
import { isContentLoading } from "../../components/ContentLoader";
import { EncryptedText, EncryptedOBJ, DecryptedOBJ, DecryptedText } from "../../utils/Encryption";
import SignIn_Navbar from "../../components/SignIn_Navbar";
import CLOSE_ICON from '../../assets/images/icons/close-btn-2.png'
import { update_idcard_detect } from "../../redux/actions/idcardocr.action";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
import { Base_API } from "../../_actions/matcher";
import { NhealthAction } from "../../_actions/action.api";
import { useNavigate } from "react-router-dom";
import PopupCheckInfo, {handlePopupCheckInfo} from "../../components/PopupCheckInfo";
import { ALERT } from "../../components/CustomAlert";
import { getJWTbyPatientID } from "../../_actions/sso.authen";

export default function SignUp_ScanCard() {
    const navigateLink = useNavigate();
    // Redux
    const idcard_store = useSelector((state) => state.idcardDetection)
    const dispatch = useDispatch();

    let PreviewCardElem = '.pr_card';

    let onceMount = useRef(true);
    const camera = useRef(null);

    const [TYPEOTP, setTYPEOTP] = useState(!!localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP)) : null); 
    const [image, setImage] = useState(null);
    const [imageBlob, setImageBlob] = useState();
    const [captureCount, setCaptureCount] = useState(1);
    const [JWT, setJWT] = useState(null);
    const [ocrData, setOcrdata] = useState(null);
    const [patientData, setPatientData] = useState(null);

    useEffect(() => {
        if (onceMount.current) {
            pageInit();
            onceMount.current = false;
        }
    }, []);

    //! old version
    // useEffect(() => {
    //     console.log("Store Changed!!");
    //     console.log(idcard_store);
    //     if(!!image)
    //     {
    //         console.log('Captureeeee!!');
    //         captureCardSuccess();
    //     }
    // }, [idcard_store]);

    const pageInit = async () => {
        let type_regis = 'idcard'
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS, EncryptedText(type_regis));
        
        await checkCameraPermission();
        await jwtInit();
        await checkCurrentURL();
        await patientInit();
        isPageLoading(false); 
    };

    const jwtInit = () => {
        return new Promise(async resolve => {
            await getJWT()
            .then(() => {
                resolve();
            })
        })
    }

    const patientInit = () => {
        return new Promise(async resolve => {
            let typeOTP = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP)) : null;
            if(typeOTP === 'kyc')
            {
                let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null; 
                let jwtData = await getJWTbyPatientID(patientData.data.patientid);
                
                let headers = {
                    token: jwtData.token,
                    userRef: patientData.data.patientid,
                    authorizeRef: jwtData.authorizeRef,
                    channalRef: jwtData.channalRef
                }
    
                let rawReq = {
                    "refEXP": patientData.refEXP,
                    "isType": patientData.isType,
                    "refAction": patientData.refAction,
                    "refType": patientData.refType,
                }
                let reqData = {
                    data: EncryptedOBJ(rawReq)
                }
    
                console.log('raw get patient req: ', rawReq);
    
                NhealthAction.GetPatientProfile(reqData, headers)
                .then(res => {
                    console.log('get patient: ', res);
                    if(res.IsSuccess)
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA, EncryptedOBJ(res))
                        setPatientData(res);
                        resolve(res);
                    }
                })
            }else
            {
                resolve();
            }
        })
    }

    const identityCompare = (detectCardData) => {
        return new Promise(async resolve => {
            let detectIdCard = detectCardData.data.Identification_Number;
            let typeOTP = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP)) : null;
            if(typeOTP === 'kyc')
            {
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OCR_HASH_SECRET, EncryptedText(detectCardData.hashSecret))
                let patientId = patientData.data.identity_id_view;
                let detectId = String(detectIdCard).substring(String(detectIdCard).length - 4, String(detectIdCard).length); 
                let patientIdCard = String(patientId).substring(String(patientId).length - 4, String(patientId).length); 
                console.log('detectId: ', detectId);
                console.log('patientIdCard:', patientIdCard);
                if(detectId === patientIdCard && detectIdCard.length === 13)
                {
                    resolve();
                }else
                {
                    handlePopupCheckInfo(true);
                }
            }else
            {
                if(detectIdCard.length === 13)
                {
                    resolve();
                }else
                {
                    handlePopupCheckInfo(true);    
                }
            }
        })
    }

    const getJWT = () => {
        return new Promise(async resolve => {
            let typeOTP = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP)) : null;

            if(!!typeOTP)
            {
                if(typeOTP === 'kyc')
                {
                    let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
                    let patientID = patientData.data.patientid;
                    let ip = await NhealthAction.GetIPAdress();
                    let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                    let udid = lineProfile.user_id;
        
                    if(!!lineProfile)
                    {
                        let reqData = {
                            UserRef: patientID,
                            IPAddress: ip,
                            Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
                        } 
                        NhealthAction.JWT_Authen(reqData)
                        .then(res => {
                            if(!!res)
                            {
                                setJWT(res);
                                localStorage.setItem(process.env.REACT_APP_ENC_NAME_JWT_DATA, EncryptedOBJ(res));
                                resolve(res);
                            }
                        })
                    }else
                    {
                        console.error('Line profile is required!');
                    }
                }else
                {
                    let ip = await NhealthAction.GetIPAdress();
                    let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                    let udid = lineProfile.user_id;
        
                    if(!!lineProfile)
                    {
                        let reqData = {
                            UserRef: udid,
                            IPAddress: ip,
                            Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
                        } 
                        NhealthAction.JWT_Authen(reqData)
                        .then(res => {
                            if(!!res)
                            {
                                setJWT(res);
                                localStorage.setItem(process.env.REACT_APP_ENC_NAME_JWT_DATA, EncryptedOBJ(res));
                                resolve(res);
                            }
                        })
                    }else
                    {
                        console.error('Line profile is required!');
                    }
                }
            }
        })
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let pathname = location.pathname;
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));

            resolve();
        })
    }

    function isIphone() {
        let userAgent = String(navigator.userAgent).toLowerCase();
        let pattern = /iphone/g 
        return pattern.test(userAgent); 
    }
    function isAndroidLineWebview() {
        let userAgent = String(navigator.userAgent).toLowerCase();
        let patternLine = /line/g;
        let patternAndroid = /android/g;
        return patternLine.test(userAgent) && patternAndroid.test(userAgent);
    }
    

    async function checkCameraPermission() {
        return new Promise(async resolve => {
            if(isIphone()){ //! Iphone
                resolve();
            } else if(isAndroidLineWebview()){ //! Line Android (Webview)
                externalBrowser();
            }else { //! Android (External browser)
                resolve();
                // await navigator.mediaDevices.getUserMedia({video: true})
                // .then(userMedia => {
                //     console.log('userMedia.active: ', userMedia.active);
                //     if(!!userMedia && !!userMedia.active){
                //         resolve();
                //     }else{
                //         ALERT.customAlert('ผิดพลาด', 'Camera access denied.', 'ปิด')
                //     }
                // }).catch(err => {
                //     console.log('Check Permission(Error): ', err);
                //     ALERT.customAlert('ผิดพลาด', String(err), 'ปิด')
                // })
            }

            function externalBrowser(){
                console.log('Camera is not Support this device!');
                let callbackURLEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL)
                console.log("callbackURLEnc: ", callbackURLEnc);
                if(!!callbackURLEnc)
                {
                    let callbackURLDec = DecryptedText(callbackURLEnc);
                    console.log('callbackURLDec: ', callbackURLDec);
                    if(callbackURLDec.indexOf('/ref') >= 0)
                    {
                        let refRedirect = !!localStorage.getItem('refredirect') ? DecryptedText(localStorage.getItem('refredirect')) : null;
                        let newCallbackURL = callbackURLDec.replace('/ref', `/${refRedirect}`)
                        let path = newCallbackURL+"/?openExternalBrowser=1";
                        openExternalLink(path);
                        // resolve();
                    }else
                    {
                        let path = callbackURLDec+"/?openExternalBrowser=1";
                        openExternalLink(path);
                        // resolve();
                    }
                }
            }
        })
    }

    function openExternalLink(url) {
        console.log('open external link: ', url);
        window.location.href = url;
    }

    const openAlert = () => {
        MySwal.fire({
            html: alertConfirmElem,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false
        });
    };

    const handleCloseAlert = () => {
        $(PreviewCardElem).fadeOut();
        isContentLoading(false);
        MySwal.close();
    }

    const skipStep = async() => {
        // Remove Old Data Register
        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_REGIS_PAYLOAD);
        // Remove old id card info
        let dataEncName = process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD;
        localStorage.removeItem(dataEncName); 

        // save card (upload image)
        let jwtData = await getJWT();
        // await uploadImage(jwtData)
        // .then(() => {
        //     // Navigate
        //     nextPage();
        // })
        nextPage();
    }

    let alertConfirmElem = (
        <div className="swal-cfpm">
            <div className="top">
                <div
                    onClick={handleCloseAlert}
                >
                    <img
                        src={CLOSE_ICON}
                    />
                </div>
            </div>

            <div className="mid">
                <h2 className="title">
                    ไม่พบข้อมูล!
                </h2>
                <p className="desc">
                    ข้อมูลไม่ครบถ้วน {captureCount >= 2 && TYPEOTP !== 'kyc' ? 'ท่านสามารถข้ามขั้นตอนนี้ หรือ ลองใหม่อีกครั้ง' : 'กรุณาลองใหม่'}
                </p>
            </div>

            <div className={`bottom ${captureCount >= 2 && TYPEOTP !== 'kyc' ? 'skip' : ''}`}>
                <button
                    type="button"
                    onClick={handleCloseAlert}
                >
                    {captureCount >= 2 && TYPEOTP !== 'kyc' ? 'ลองใหม่' : 'ตกลง'}
                </button>
                {
                    captureCount >= 2 && TYPEOTP !== 'kyc' ?
                    <button
                        type="button"
                        onClick={skipStep}
                    >
                        ข้าม
                    </button>
                    : ''
                }
            </div>
        </div>
    );

    const nextPage = () => {
        let pathname = String(location.pathname).toLowerCase().replace(Base_API.pathWeb, '');

        if(pathname === '/n-health/kyc/idcard-ocr' || pathname === '/n-health/kyc/idcard-ocr/')
        {
            const path = `${Base_API.pathWeb}/n-health/kyc/face-ocr` 
            window.location.href = path;
        }else
        {
            const path = `${Base_API.pathWeb}/n-health/signup/forminfo` 
            window.location.href = path;
        }
    }

    const skipFaceScan = () => {
        let pathname = String(location.pathname).toLowerCase().replace(Base_API.pathWeb, '');

        if(pathname === '/n-health/kyc/idcard-ocr' || pathname === '/n-health/kyc/idcard-ocr/')
        {
            const path = `${Base_API.pathWeb}/n-health/kyc/step-1` 
            window.location.href = path;
        }else
        {
            const path = `${Base_API.pathWeb}/n-health/signup/forminfo` 
            window.location.href = path;
        }
    }

    const onCapture = async() => {
        isContentLoading(true);

        // Capture photo
        const capturedImage = camera.current.takePhoto();
        setCaptureCount(captureCount+1);
        
        // 1. Change image filter to grayscale (optional)
        const imageElement = new Image();
        imageElement.src = capturedImage;
        imageElement.onload = async() => {
            var file = dataURLtoFile(capturedImage, 'captureidcard-test.jpg');
            let fileUpload = base64ToImageFile(capturedImage, 'idcard.jpg')
            setImageBlob(file);
            setImage(capturedImage);
            // Active Card Preview
            $(PreviewCardElem).fadeIn();

            // 2. Find out id card data
            await _OCR_IDCARD(fileUpload)
            .then(async (res) => {
                isContentLoading(false);
                setOcrdata(res.data);
                identityCompare(res)
                .then(() => {
                    onSubmit(res.data);
                })
                console.log('ocr res: ', res);
            })
        };
    }


    function base64ToImageFile(base64, filename) {
        const arr = base64.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    const reTry = () => {
        $(PreviewCardElem).fadeOut();
        isContentLoading(false);
        handlePopupCheckInfo(false);
    }
    const onSubmit = async (data) => {
        $(PreviewCardElem).fadeOut();
        isContentLoading(true);
        handlePopupCheckInfo(false);

        if(!!data.Identification_Number)
        {
            // Encrypt data before go to next page
            let rawData = {
                card_id: data.Identification_Number,
                full_name: `${data.NameTH} ${data.LastNameTH}`,
                full_name_en: `${data.NameEN} ${data.LastNameEN}`,
                dob: moment(data.BirthdayEN, 'DD MMM. YYYY').format('DD-MM-YYYY'),
                image_id_card: data.imageIDCard
            }
            let dataEncName = process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD;
            let dataEnc = EncryptedOBJ(rawData);
            localStorage.setItem(dataEncName, dataEnc);
    
            // save card (upload image)
            // let jwtData = await getJWT();
            // await uploadImage(jwtData)
            // .then(() => {
            //     console.log('next page')
            //     nextPage();
            // })
            nextPage();
        }else
        {
            ALERT.customAlert('ไม่สามารถตรวจสอบข้อมูลได้', 'กรุณาถือโทรศัพท์องคุณไว้เหนือบัตรในที่ที่มีแสงสว่างเพียงพอ โดยต้องสามารถมองเห็นข้อมูลได้ชัดเจน แล้วลองใหม่อีกครั้ง.', 'ลองใหม่', () => {
                reTry();
            })
        }

    }

    function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    }

    const _OCR_IDCARD = (image) => {
        return new Promise(async resolve => {
            let formData = new FormData();
            formData.append('image_front_card', image);
            NhealthAction.OCRfrontIdCard(formData)
            .then(res => {
                if(res.isSuccess)
                {
                    console.log('ocr: ', res.data);
                    resolve(res);
                }else
                {
                    console.log('Error: ', res.message);
                    ALERT.customAlert('ไม่สามารถตรวจสอบข้อมูลได้', 'กรุณาถือโทรศัพท์องคุณไว้เหนือบัตรในที่ที่มีแสงสว่างเพียงพอ โดยต้องสามารถมองเห็นข้อมูลได้ชัดเจน แล้วลองใหม่อีกครั้ง.', 'ลองใหม่', () => {
                        reTry();
                    })
                }
            })
        })
    }

    // Function to preprocess the image and remove noise
    function preprocessImage(imageElement) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = imageElement.width;
        canvas.height = imageElement.height;

        // Apply grayscale filter
        context.filter = "grayscale(100%)";
        context.drawImage(imageElement, 0, 0, canvas.width, canvas.height);

        // Convert the image data to grayscale pixel values
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        for (let i = 0; i < data.length; i += 4) {
            const average = (data[i] + data[i + 1] + data[i + 2]) / 3;
            data[i] = average;
            data[i + 1] = average;
            data[i + 2] = average;
        }
        context.putImageData(imageData, 0, 0);

        // Apply noise removal techniques here (e.g., median filter, thresholding, etc.)
        // You can use libraries like ImageJS or create custom algorithms

        return canvas.toDataURL("image/jpeg");
    }

    function canvasToBlob(imageElement) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = imageElement.width;
        canvas.height = imageElement.height;
    
        // Apply grayscale filter
        context.drawImage(imageElement, 0, 0, canvas.width, canvas.height);
    
        // Convert the image data to grayscale pixel values
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        for (let i = 0; i < data.length; i += 4) {
            const average = (data[i] + data[i + 1] + data[i + 2]) / 3;
            data[i] = average;
            data[i + 1] = average;
            data[i + 2] = average;
        }
        context.putImageData(imageData, 0, 0);
    
        // Create a Blob from the canvas data
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            }, "image/jpeg");
        });
    }

    function findoutIDCardData(lines)
    {
        return new Promise(async (resolve, reject) => {
            if(lines.length > 0)
            {
                // Find Data (ID Card)
                Promise.all([findCardID(lines), findFullName(lines), findDOB(lines)])
                .then(value => {
                    let cardid_data = value[0]
                    let fullname_data = value[1]
                    let dob_data = value[2]
                    let fullnameValidate = String(idcard_store.full_name).indexOf('null') >= 0;

                    if(idcard_store.card_id === null && !!cardid_data)
                    {
                        let payload = {
                            card_id: cardid_data
                        }
                        dispatch(update_idcard_detect(payload));
                    }else if(idcard_store.card_id === null && cardid_data === null)
                    {
                        let payload = {
                            card_id: null
                        }
                        dispatch(update_idcard_detect(payload));
                    }
                    if((idcard_store.full_name === null || fullnameValidate) && !!fullname_data)
                    {
                        let payload = {
                            full_name: fullname_data
                        }
                        dispatch(update_idcard_detect(payload));
                    }else if((idcard_store.full_name === null || fullnameValidate) && fullname_data === null)
                    {
                        let payload = {
                            full_name: null
                        }
                        dispatch(update_idcard_detect(payload));
                    }
                    if((idcard_store.dob === null || idcard_store.dob === 'Invalid date') && !!dob_data)
                    {
                        let payload = {
                            dob: dob_data
                        }
                        dispatch(update_idcard_detect(payload));
                    }else if((idcard_store.dob === null || idcard_store.dob === 'Invalid date') && dob_data === null)
                    {
                        let payload = {
                            dob: null
                        }
                        dispatch(update_idcard_detect(payload));
                    }
                    resolve(); 
                })
            }
        })
    }

    const captureCardSuccess = async() => {
        console.log('(Changed) Card ID: ', idcard_store.card_id);
        console.log('(Changed) Full Name: ', idcard_store.full_name);
        console.log('(Changed) DOB: ', idcard_store.dob);

        let fullnameValidate = String(idcard_store.full_name).indexOf('null') < 0;
        if(!!idcard_store.card_id && !!idcard_store.full_name && fullnameValidate === true && !!idcard_store.dob && idcard_store.dob !== 'Invalid date')
        {
            // Encrypt data before go to next page
            let dataEncName = process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD;
            let dataEnc = EncryptedOBJ(idcard_store);
            localStorage.setItem(dataEncName, dataEnc);

            // save card (upload image)
            let jwtData = await getJWT();
            await uploadImage(jwtData)
            .then(() => {
                console.log('next page')
                nextPage();
            })
        }else
        {
            openAlert();
        }
    }

    const uploadImage = (jwtData) => {
        return new Promise(async resolve => {
            let typeOTP = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP)) : null;

            if(typeOTP === 'register')
            {
                let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                let udid = lineProfile.user_id;
    
                console.log('image blob: ', imageBlob);
    
                let formData = new FormData();
                formData.append('file', imageBlob, 'idcard.jpg');
    
                let headers = {
                    token: jwtData.token,
                    userRef: udid,
                    authorizeRef: jwtData.authorizeRef,
                    channalRef: jwtData.channalRef
                }
    
                NhealthAction.uploadImage(formData, headers)
                .then(res => {
                    console.log(res);
                    if(res.IsSuccess)
                    {
                        let pathFile = res.data[0]._image; 
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_IDCARD_IMAGE_URL, pathFile)
    
                        resolve();
                    }
                })
                resolve();
            }
            if(typeOTP === 'kyc')
            {
                let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
                let patientID = patientData.data.patientid;

                if(!!patientData)
                {
                    let formData = new FormData();
                    formData.append('file', imageBlob, 'idcard.jpg');
        
                    let headers = {
                        token: jwtData.token,
                        userRef: patientID,
                        authorizeRef: jwtData.authorizeRef,
                        channalRef: jwtData.channalRef
                    }
        
                    NhealthAction.uploadImage(formData, headers)
                    .then(res => {
                        console.log(res);
                        if(res.IsSuccess)
                        {
                            let pathFile = res.data[0]._image; 
                            localStorage.setItem(process.env.REACT_APP_ENC_NAME_IDCARD_IMAGE_URL, pathFile)
        
                            resolve();
                        }
                    })
                    resolve();
                }
            }
        })
    }

    const findDOB = (lines) => {
        return new Promise(async (resolve) => {
            let result = null
            lines.map(async(item, i) => {
                let text = keepTextAndNumber(String(item.text).replaceAll(" ", ""));
                let dob = await dobValidator(text);

                if(!!dob)
                {
                    console.log('Get DOB: ', `${dob.slice(0, 2)}-${dob.slice(2, 5)}-${dob.slice(5, 9)}`);
                    result = moment(`${dob.slice(0, 2)}-${dob.slice(2, 5)}-${dob.slice(5, 9)}`, 'DD-MMM-YYYY').format('DD-MM-YYYY');
                }
                // Last Loop
                if(i === lines.length-1)
                {
                    console.log('DOB Result: ', result);
                    resolve(result);
                }
            })
        })
    }
    const dobValidator = (text) => {
        return new Promise(async (resolve) => {
            let lowerText = String(text).toLowerCase().replace(/[^a-z0-9]/g, '');;
            let dob = null;

            // Name Miss
            if(
                lowerText.indexOf('dateofbirth') >= 0
                ||
                lowerText.indexOf('dateofburth') >= 0
            ){
                dob = String(lowerText).slice(11, lowerText.length)
            }
            resolve(dob);
        })
    }
    const findFullName = (lines) => {
        return new Promise(async (resolve) => {
            let result = null;
            let firstName = null;
            let lastName = null;

            lines.map(async(item, i) => {
                let text = keepOnlyEnglishLetters(String(item.text).replaceAll(" ", ""));
                let f_name =  await firstNameValidation(text);
                let l_name =  await lastNameValidation(text);

                if(!!f_name) 
                {
                    firstName = f_name;
                }
                if(!!l_name)
                {
                    lastName = l_name;
                }

                // Last Loop
                if(i === lines.length-1)
                {
                    if(firstName === 'null' || lastName === 'null')
                    {
                        result = null
                    }else
                    {
                        result = `${firstName} ${lastName}`
                    }
                    console.log('Result Fullname: ', result);
                    resolve(result);
                }
            }) 
        })
    }
    const firstNameValidation = (text) => {
        return new Promise(async resolve => {
            let lowerText = String(text).toLowerCase();
            let firstName = null;

            // Name Mr. && Mrs
            if(
                lowerText.indexOf('namemr') >= 0
                ||
                lowerText.indexOf('nememr') >= 0
                ||
                lowerText.indexOf('namemrs') >= 0
                ||
                lowerText.indexOf('nememrs') >= 0
            ){
                let raw_firstName = String(text).split('.')
                firstName = raw_firstName[raw_firstName.length-1]
            }
            // Name Miss
            if(
                lowerText.indexOf('namemiss') >= 0
                ||
                lowerText.indexOf('nememiss') >= 0
            ){
                firstName = String(text).slice(8, text.length)
            }
            resolve(firstName);
        })
    }
    const lastNameValidation = (text) => {
        return new Promise(async resolve => {
            let lowerText = String(text).toLowerCase();
            let lastName = null;

            if(
                lowerText.indexOf('lastname') >= 0
                ||
                lowerText.indexOf('lastneme') >= 0
            ){
                lastName = String(text).slice(8, text.length);
            }
            resolve(lastName);
        })        
    }
    const findCardID = (lines) => {
        return new Promise(async (resolve) => {
            let result = null
            console.log('line(findCardID): ', lines);
            lines.map((item, i) => {
                let text = replaceNonNumericCharacters(String(item.text).replaceAll(" ", ""));
                console.log('text: ', text);
                // let text = '1710501450353'

                if(text.length === 13 && !!text && idCardCheck(text) === true && result === null)
                {
                    result = text;
                }

                // Last Loop
                if(i === lines.length-1)
                {
                    console.log('Result cardid: ', result);
                    resolve(result);
                }
            })
        })
    }
    function idCardCheck(idCardNumber) {
        var sum = 0;
        for (var i = 0; i < idCardNumber.length - 1; i++) {
          sum += parseInt(idCardNumber[i]) * (13 - i);
        }
        
        var checkDigit = (11 - (sum % 11)) % 10;
        
        if (checkDigit == idCardNumber[12]) {
          return true;
        } else {
          return false;
        }
    }

    function replaceNonNumericCharacters(inputString) {
        return inputString.replace(/[^0-9]/g, '');
    }
    function keepOnlyEnglishLetters(inputString) {
        return inputString.replace(/[^a-zA-Z-.]/g, '');
    }
    function keepTextAndNumber(inputString) {
        return inputString.replace(/[^a-zA-Z-0-9]/g, '');
    }

    return (
        <div className="con-scan-card">
            <div className="page-content">
                <div className="head">
                    {/* <p>กรุณาวางบัตรให้ตรงกรอบที่กำหนด เห็นตัวอักษร
                        และข้อมูลให้ชัดเจน </p> */}
                </div>

                <div className="content-image">
                    <Camera 
                        ref={camera}
                        aspectRatio={3 / 2} 
                        facingMode="environment"
                    />
                    <img className="idcard-frame" src={IDCARD_FRAME} />
                    <img src={image} className="pr_card" />
                </div>

                <div className="capture">
                    <div onClick={onCapture}>
                        <img src={CAPTURE_ICON} />
                    </div>
                </div>

                {/* <button className="skip-btn" onClick={skipStep}>ข้ามขั้นตอนนี้</button> */}
            </div>
            <PageLoader />
            <ContentLoader />
            <SignIn_Navbar canClose={false}/>
            <PopupCheckInfo data={ocrData} onClose={reTry} onSubmit={onSubmit} onSkip={skipStep} />
        </div>
    )
}